import { FIELD_TYPES } from '@iconik-io/shared-lib/src/constants/search';

import { MIN_COLUMN_WIDTH } from './table';
import type { Column } from './types';

export const renderColumnsWithMenu = <T>(columns: Column<T>[]) => {
  return [
    ...columns,
    {
      label: ' ',
      name: 'id',
      type: FIELD_TYPES.MENU,
      style: { width: MIN_COLUMN_WIDTH },
    },
  ];
};
